module.exports = __webpack_public_path__ + "img/News_item_5.ad852930.jpg";